import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import {
  StyledButton,
  StyledButtonContainer,
  ModalContent,
  ModalOverlay,
  ModalCard,
  ModalHeader,
  ModalActions
} from './ConfirmationModal.styles';

const ConfirmationModal = ({
  open,
  onConfirm,
  onClose,
  title,
  confirmButtonText,
  cancelButtonText = 'Cancel',
  confirmButtonColor = 'primary'
}) => {
  const handleConfirmClick = () => {
    onConfirm();
    onClose();
  };

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <AnimatePresence>
      {open && (
        <ModalOverlay
          as={motion.div}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={handleBackdropClick}
        >
          <ModalCard
            as={motion.div}
            initial={{
              opacity: 0,
              scale: 0.8,
              y: 20
            }}
            animate={{
              opacity: 1,
              scale: 1,
              y: 0
            }}
            exit={{
              opacity: 0,
              scale: 0.8,
              y: 20
            }}
            transition={{
              type: "spring",
              damping: 25,
              stiffness: 300
            }}
          >
            <ModalContent>
              <ModalHeader>
                {typeof title === 'string' ? (
                  <Typography variant="h6" component="h2">
                    {title}
                  </Typography>
                ) : (
                  title
                )}
              </ModalHeader>

              <ModalActions>
                <StyledButtonContainer>
                  <StyledButton
                    onClick={onClose}
                    isCancel={true}
                    as={motion.button}
                    whileHover={{
                      scale: 1.02,
                      transition: { duration: 0.2 }
                    }}
                    whileTap={{
                      scale: 0.98,
                      transition: { duration: 0.1 }
                    }}
                  >
                    {cancelButtonText}
                  </StyledButton>
                  <StyledButton
                    onClick={handleConfirmClick}
                    isCancel={false}
                    color={confirmButtonColor}
                    as={motion.button}
                    whileHover={{
                      scale: 1,
                      transition: { duration: 0.2 }
                    }}
                    whileTap={{
                      scale: 0.97,
                      transition: { duration: 0.1 }
                    }}
                  >
                    {confirmButtonText}
                  </StyledButton>
                </StyledButtonContainer>
              </ModalActions>
            </ModalContent>
          </ModalCard>
        </ModalOverlay>
      )}
    </AnimatePresence>
  );
};

ConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  confirmButtonText: PropTypes.string.isRequired,
  cancelButtonText: PropTypes.string,
  confirmButtonColor: PropTypes.string,
};

export default ConfirmationModal;
